// Mock data used as fallback / seed reference. Backend serves the live data.

export const stats = [
  { value: '20 years', label: 'building technology products' },
  { value: '15+ years', label: 'in product leadership' },
  { value: '$100M+', label: 'business impact influenced' },
  { value: '4 iconic companies', label: 'Amazon, Apple, Microsoft, Walmart' },
];

export const companies = ['Amazon', 'Apple', 'Microsoft', 'Walmart', 'eBay', 'Rubrik', 'Paylocity'];

export const programs = [
  {
    index: '01', kicker: 'PERSONAL', accent: '#2E6BFF',
    title: '1:1 Product Mentorship',
    desc: 'Dedicated guidance for product managers navigating interviews, promotions, role changes, or higher-stakes leadership.',
    points: ['Career and leadership roadmap', 'Interview and story coaching', 'Live decision support'],
    cta: 'Request a mentorship spot',
  },
  {
    index: '02', kicker: 'LEARN', accent: '#7C3AED',
    title: 'Technology & AI Courses',
    desc: 'Compact, applied programs that help PMs and builders understand AI, make stronger product decisions, and ship with confidence.',
    points: ['AI for Product Managers', 'World-Class PM foundations', 'Hands-on cohort learning'],
    cta: 'Join the next cohort',
  },
  {
    index: '03', kicker: 'READ', accent: '#F59E0B',
    title: 'Books & Field Guides',
    desc: 'Ideas and practical frameworks for product leadership, career reinvention, and thriving as a woman in technology.',
    points: ['Product playbooks', 'Career and leadership essays', 'New releases and signed editions'],
    cta: 'See upcoming releases',
  },
  {
    index: '04', kicker: 'SOLVE', accent: '#10B981',
    title: 'Strategy Sessions',
    desc: 'A focused working session for founders and product leaders facing a critical product, platform, positioning, or go-to-market decision.',
    points: ['90-minute working session', 'Clear decision and action plan', 'Written follow-up summary'],
    cta: 'Book a strategy session',
  },
  {
    index: '05', kicker: 'INSPIRE', accent: '#EF4444',
    title: 'Speaking Engagements',
    desc: 'High-energy, practical talks for conferences, leadership offsites, and company events—grounded in two decades of building technology products.',
    points: ['Product and AI leadership keynotes', 'Women in technology and career resilience', 'Custom talks for your audience'],
    cta: 'Invite Rajni to speak',
  },
  {
    index: '06', kicker: 'TRANSFORM', accent: '#06B6D4',
    title: 'Corporate Product Training',
    desc: 'Custom workshops that strengthen product judgment, AI fluency, strategy, and execution across your product organization.',
    points: ['Half-day, full-day, or multi-session programs', 'Tailored to your team and business context', 'Interactive tools and real company challenges'],
    cta: 'Discuss team training',
  },
];

export const steps = [
  { n: '1', title: 'Name the real challenge', desc: 'Clarify the role, skill, product decision, or leadership moment that matters now.' },
  { n: '2', title: 'Build your operating model', desc: 'Use practical frameworks, direct feedback, and examples drawn from complex environments.' },
  { n: '3', title: 'Act with conviction', desc: 'Leave with language, tools, and a clear next move you can use immediately.' },
];

export const heroImage = 'https://images.pexels.com/photos/7794060/pexels-photo-7794060.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940';

export const heroSlides = [
  'https://images.unsplash.com/photo-1664382953481-141e97ad9825?crop=entropy&cs=srgb&fm=jpg&auto=format&fit=crop&w=1100&q=75',
  'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?crop=entropy&cs=srgb&fm=jpg&auto=format&fit=crop&w=1100&q=75',
  'https://images.unsplash.com/photo-1590650516494-0c8e4a4dd67e?crop=entropy&cs=srgb&fm=jpg&auto=format&fit=crop&w=1100&q=75',
  'https://images.pexels.com/photos/19895774/pexels-photo-19895774.jpeg?auto=compress&cs=tinysrgb&w=1100',
  'https://images.unsplash.com/photo-1523240795612-9a054b0db644?crop=entropy&cs=srgb&fm=jpg&auto=format&fit=crop&w=1100&q=75',
  'https://images.unsplash.com/photo-1531545514256-b1400bc00f31?crop=entropy&cs=srgb&fm=jpg&auto=format&fit=crop&w=1100&q=75',
];
export const portraitImage = 'https://customer-assets-v7afamib.emergentagent.net/job_pm-coaching-hub/artifacts/avmm0jhy_headshot1-B%20copy%202.webp';
